module.exports = __webpack_public_path__ + "static/media/failure.693ea162.svg";